export const CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_REJEITADO = 0;
export const CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_APROVADO = 1;
export const CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_COOP = 2;

export const allContratoEntePrivadoAcaoAvalia = [
  CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_REJEITADO,
  CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_APROVADO,
  CONTRATO_ENTE_PRIVADO_ACAO_AVALIA_COOP,
];
